const NOTIFICATION_STORAGE_KEY = '_flash_notification';

interface NotificationData {
  heading?: string;
  variant?: string;
  message?: string;
}

class Notification {
  static get notification(): NotificationData {
    const _notification = sessionStorage.getItem(NOTIFICATION_STORAGE_KEY);

    if (!_notification) return {};

    return JSON.parse(_notification) as NotificationData;
  }

  static set notification(notificationParams: NotificationData) {
    sessionStorage.setItem(
      NOTIFICATION_STORAGE_KEY,
      JSON.stringify(notificationParams)
    );
  }

  static flash(heading: string, variant = 'info', message?: string): void {
    this.notification = { heading, variant, message };
  }

  static clear(): void {
    sessionStorage.removeItem(NOTIFICATION_STORAGE_KEY);
  }
}

export default Notification;
